import React from 'react'
import { Modal } from 'react-bootstrap'

type props = {
  showModal?: boolean
  setShowModal: CallableFunction
  content?: string
  title?: string
  email?: string | boolean
  onOk?: CallableFunction
  disableCancel?: boolean
}
const AccessSuccessModal: React.FC<props> = ({
  showModal,
  setShowModal,
  content,
  title,
  email,
  onOk,
  disableCancel,
}) => {
  const handleClose = (type: any) => {
    if (type == 'ok' && onOk) {
      onOk()
    }
    if (!type) {
      !disableCancel && setShowModal(false)
    } else {
      setShowModal(false)
    }
  }
  return (
    <Modal show={showModal} centered className='submit-modal'>
      <div className='modal-header flex-column border-0 pb-2'>
        <button
          type='button'
          className='btn-close'
          onClick={() => {
            handleClose('ok')
          }}
        />
      </div>
      <div className='modal-body pt-0'>
        <div className='submit-div'>
          <div className='submit-img'>
            <span>
              <i className='ti ti-check' />
            </span>
          </div>
          <div className='forgotPassword submit-content'>
            <h4> {title}</h4>
            <p> {content}</p>
            <h5> {email}</h5>
          </div>
        </div>
      </div>
      <div className='modal-footer justify-content-end border-0 pt-0'>
        <button
          type='button'
          className='btn btn-primary'
          onClick={() => {
            handleClose('ok')
          }}
        >
          Ok
        </button>
      </div>
    </Modal>
  )
}

export default AccessSuccessModal
